module.exports = __webpack_public_path__ + "media/application/images/icons/facebook-7dd57864fc2aab5d7126261f21591198.svg";